'use client';

import { Toaster, ToastBar, type Toast } from 'react-hot-toast';

/** react-hot-toast tags every toast role="status" aria-live="polite"; an error must interrupt (WCAG 4.1.3, 2.1). */
export function withLiveRegionRole(t: Toast): Toast {
  return t.type === 'error' ? { ...t, ariaProps: { role: 'alert', 'aria-live': 'assertive' } } : t;
}

export function AccessibleToaster(props: Omit<React.ComponentProps<typeof Toaster>, 'children'>) {
  return <Toaster {...props}>{(t) => <ToastBar toast={withLiveRegionRole(t)} position={t.position ?? props.position} />}</Toaster>;
}
